import IdentificationTypeLoader from '../../../components/loaders/IdentificationTypeLoader';
import { useParameters } from '../../../hooks/useParameters';
import TeacherCreate from './TeacherCreate';

export default function TeacherCreateContainer() {
  // Preserve prior behaviour: the teacher flow scopes identification types
  // to the tenant default country (global types + types for the default
  // country). The legacy backend endpoint did this server-side; the shared
  // loader now uses the generic endpoint and passes the countryId explicitly.
  const { defaultCountry } = useParameters();

  return (
    <IdentificationTypeLoader countryId={defaultCountry ?? null}>
      <TeacherCreate />
    </IdentificationTypeLoader>
  );
}
